module.exports = __webpack_public_path__ + "static/media/finger.633d9216.svg";